import { render, staticRenderFns } from "./MajorInfo.vue?vue&type=template&id=546c2844&scoped=true&"
import script from "./MajorInfo.vue?vue&type=script&lang=js&"
export * from "./MajorInfo.vue?vue&type=script&lang=js&"
import style0 from "./MajorInfo.vue?vue&type=style&index=0&id=546c2844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c2844",
  null
  
)

export default component.exports